import { getApiBaseUrl } from "../config/apiBase";
import { apiFetch } from "../config/apiFetch";

export async function changeConsolePassword(currentPassword: string, newPassword: string): Promise<void> {
  const base = getApiBaseUrl();
  const res = await apiFetch(`${base}/api/auth/change-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ currentPassword, newPassword }),
  });
  const j = (await res.json().catch(() => ({}))) as { error?: string };
  if (!res.ok) {
    throw new Error(j.error || `Could not update password (${res.status})`);
  }
}
